import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { findCustomer } from '../../../services/customer/customerService';
import APIError from '../../../services/APIError';
import Search from '../../common/Search/Search';
import SearchContext from '../../../context/search-context';


function CustomerSearch() {
  const navigation = useNavigate();
  const searchCtx = useContext(SearchContext);
  const searchLimit = 100;

  const searchSubmitHandler = async (input: string) => {
    try {
      const result = await findCustomer({ searchText: input });
      if (result.length > searchLimit) {
        searchCtx.setShowNotification(true);
        result.pop();
      } else {
        searchCtx.setShowNotification(false);
      }
      searchCtx.setSearchResult(result);
      navigation('/search');
    } catch (err) {
      if (err instanceof APIError) {
        if (err.status === 403) {
          navigation('/denied');
        }
        console.log(`Failed to find customers: ${err.errorBody}`);
      } else {
        console.log(err);
      }
    }
  };

  return (
    <Search onSubmit={searchSubmitHandler} />
  );
}

export default CustomerSearch;
